module.exports = __webpack_public_path__ + "img/table-2.c5aca120.jpg";